import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const TestAuth = () => {
  const { isAuthenticated, user, login, logout } = useAuth();
  const navigate = useNavigate();

  const handleTestLogin = async () => {
    try {
      await login('superadmin@example.com', 'password');
    } catch (error) {
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Authentication Test Page</h1>
      
      <div className="space-y-4">
        <div className="p-4 bg-gray-100 rounded">
          <p><strong>Is Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}</p>
          <p><strong>User:</strong> {user ? JSON.stringify(user, null, 2) : 'None'}</p>
        </div>

        <div className="space-x-4">
          <button 
            onClick={handleTestLogin}
            className="btn btn-primary"
          >
            Test Login
          </button>
          
          <button 
            onClick={handleLogout}
            className="btn btn-secondary"
          >
            Test Logout
          </button>
          
          <button 
            onClick={() => navigate('/dashboard')}
            className="btn btn-outline"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestAuth;